// client/src/pages/ExamResults/index.jsx
export default function ExamResults() {
  return <div>תוצאות מבחן - בקרוב</div>;
}